import React from "react";

const UpscMain = () => {
  return (
    <div className="container my-5" style={{ paddingBottom: "70px" }}>
      {/* Introduction */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">
          An Overview of the Civil Services Exam
        </h3>
        <p>
          The UPSC Civil Services Examination (CSE) is considered one of the
          most challenging and prestigious exams in India. Every year, lakhs of
          aspirants compete for a limited number of positions, hoping to serve
          the nation in administrative roles.
        </p>
        <p>
          Success in this exam not only brings career stability but also an
          opportunity to make a significant impact on society. However, clearing
          the exam requires dedication, strategic preparation, and perseverance.
        </p>
      </div>

      {/* Competition & Toughness */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">
          Why is UPSC CSE Considered Difficult?
        </h3>
        <p>
          While the syllabus is not extremely difficult, the vastness of topics
          and intense competition make it one of the toughest exams in India.
          Every year, over a million candidates apply, but only a few hundred
          secure final selection.
        </p>
        <p>Below are some statistics from recent years:</p>
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Year</th>
              <th>Applicants</th>
              <th>Appeared for Prelims</th>
              <th>Final Selection</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>2020-21</td>
              <td>10,56,835</td>
              <td>4,86,952</td>
              <td>922</td>
            </tr>
            <tr>
              <td>2019-20</td>
              <td>11,54,769</td>
              <td>5,74,980</td>
              <td>829</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Right Strategy & Attitude */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">
          The right strategy leads to achievement
        </h3>
        <p>
          The UPSC CSE is not just about acquiring knowledge. It tests a
          candidate’s ability to analyze, think critically, and form
          well-balanced opinions on various issues. Developing an analytical
          mindset and staying updated with current affairs is crucial.
        </p>
        <p>
          Additionally, resilience and a positive attitude play a huge role.
          Given the long duration of the examination cycle, aspirants must be
          prepared for setbacks and stay focused throughout their journey.
        </p>
      </div>

      {/* Final Motivation */}
      <div className="mb-4">
        <h3 className="fw-semibold text-dark">
          Stay focused and keep pushing forward
        </h3>
        <p>
          If you aspire to become a civil servant, start by understanding the
          syllabus, solving previous years’ question papers, and seeking the
          right guidance. Success in UPSC CSE is not about talent but
          perseverance.
        </p>
        <blockquote className="blockquote">
          <p className="mb-0">
            "Success is not final, failure is not fatal: it is the courage to
            continue that counts." – Winston Churchill
          </p>
        </blockquote>
      </div>
    </div>
  );
};

export default UpscMain;
